//import { Injectable } from '@angular/core';
//import { Params } from '@angular/router';
// import { Observable } from 'rxjs/Observable';
// import { forkJoin } from 'rxjs/observable/forkJoin';
//import { Http, Headers, RequestOptions } from '@angular/http';
//import { LogService } from '../logger/loggerProvider/loggerhelper.service';
//import { DashboardConfigManager } from './dashboard.config.service';
import { PmDatapointPropertyDetail} from '../../interfaces/pm.barchart.response.interface';

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { forkJoin, Observable } from "rxjs";
import { LogService } from '../../logger';
import { DashboardConfigManager } from '../dashboard.config.service';


@Injectable()
export class PmPropertyDescriptionService {

  constructor(private http: HttpClient,
    private logger: LogService,
    private dashboardConfig: DashboardConfigManager) {
  }

  public getPropertyDescription(showDPDescription: boolean, showPropertyDescription: boolean, propertyId: any, headers: HttpHeaders): Observable<string> {
    let propertyDescription: string = propertyId;
    let result = Observable.create(observer => {
      if (propertyId && propertyId != null) {
        let systemId = 0;
        var seriesId: any[] = [];
        let forkJoins: Observable<any>[] = [];
        let baseURL = this.dashboardConfig.getBaseUrl();

        if (showDPDescription) {
          let systemName = propertyId.split(':')[0];
          systemId = this.dashboardConfig.hasSystemData && (this.dashboardConfig.systemData.find(x => x.Name === systemName)) ? (this.dashboardConfig.systemData.find(x => x.Name === systemName)).Id : systemId;
          seriesId.push(propertyId);
          //let requestOptions = new RequestOptions({ headers: headers });
          let descriptorUrl = baseURL + "/api/systembrowser/" + systemId;
          forkJoins.push(this.http.post(descriptorUrl, seriesId,  { headers: headers }))
        }
        if (showPropertyDescription) {
          let propertyUrl = baseURL + '/api/properties/' + propertyId;
          forkJoins.push(this.http.get(propertyUrl, {
            headers: headers
          }))
        }
        forkJoin(forkJoins).subscribe({next:result => {
          if (result && result.length > 1) {
            let dpData = result[0];
            let propertyData = result[1];

            let propertyDescriptor = "";
            if (propertyData && propertyData.Properties && propertyData.Properties[0].Descriptor) {
              propertyDescriptor = propertyData.Properties[0].Descriptor;
            }
            else {
              this.logger.logInfo("PmPropertyDescriptionService", "Unable to get property description for " + propertyId)
            }

            let dpDescriptor = "";
            if (dpData && dpData.length > 0 && dpData[0].Nodes.length > 0 && dpData[0].Nodes[0].Descriptor) {
              dpDescriptor = dpData[0].Nodes[0].Descriptor;
            }
            else {
              this.logger.logInfo("PmPropertyDescriptionService", "Unable to get point/device description for " + propertyId)
            }
            if (propertyDescriptor !== "" && dpDescriptor !== "") {
              propertyDescriptor = " [" + propertyDescriptor + "]";
            }
            propertyDescription = dpDescriptor + propertyDescriptor;
          }
          else {
            let data = result[0];
            if (showDPDescription && data && data.length > 0 && data[0].Nodes.length > 0 && data[0].Nodes[0].Descriptor) {
              propertyDescription = data[0].Nodes[0].Descriptor;
            }
            else if (showPropertyDescription && data && data.Properties && data.Properties[0].Descriptor) {
              propertyDescription = data.Properties[0].Descriptor;
            }
            else {
              this.logger.logInfo("PmPropertyDescriptionService", "Unable to get property/device description for " + propertyId)
            }
          }
          observer.next(propertyDescription);
          observer.complete();
        },error:error => {
          this.logger.logError('PmPropertyDescriptionService', "unable to get dpid for:" + error);
          observer.next(propertyDescription);
          observer.complete();
        }});
      }
      else {
        observer.next(propertyDescription);
      }
    })
    return result;
  }

  public getPropertyDetails(propertyId: any, headers: HttpHeaders): Observable<PmDatapointPropertyDetail> {
    let propertyDetail: PmDatapointPropertyDetail;
    let result = Observable.create(observer => {
      if (propertyId && propertyId != null) {
        let systemId = 0;
        var seriesId: any[] = [];
        let dpPropertyData: Observable<any>[] = [];
        let baseURL = this.dashboardConfig.getBaseUrl();

        let systemName = propertyId.split(':')[0];
        systemId = this.dashboardConfig.hasSystemData && (this.dashboardConfig.systemData.find(x => x.Name === systemName)) ? (this.dashboardConfig.systemData.find(x => x.Name === systemName)).Id : systemId;
        seriesId.push(propertyId);
        //let requestOptions = new RequestOptions({ headers: headers });
        // to get Dp descriptiom
        let descriptorUrl = baseURL + "/api/systembrowser/" + systemId;
        dpPropertyData.push(this.http.post(descriptorUrl, seriesId,  { headers: headers }));

        // to get property details
        let propertyUrl = baseURL + '/api/properties/' + propertyId;
        dpPropertyData.push(this.http.get(propertyUrl, { headers: headers }));

        forkJoin(dpPropertyData).subscribe(combinedJsonData => {
          let dpName = "";
          let propertyName = "";
          let propertyDescriptor = "";
          let unitDescriptor = "";
          let dpDescriptor = "";
          let resolution= "";

          if (combinedJsonData && combinedJsonData.length > 1) {
            let dpData = combinedJsonData[0];
            let propertyData = combinedJsonData[1];

            if (propertyData) {
              if (propertyData[0].ObjectId) {
                dpName = propertyData[0].ObjectId;
              }
              if (propertyData[0].Properties) {
                if (propertyData[0].Properties[0].PropertyName) {
                  propertyName = propertyData[0].Properties[0].PropertyName;
                }
                if (propertyData[0].Properties[0].Descriptor) {
                  propertyDescriptor = propertyData[0].Properties[0].Descriptor;
                }
                else {
                  this.logger.logInfo("PmPropertyDescriptionService", "property description not found for " + propertyId)
                }
                if (propertyData[0].Properties[0].UnitDescriptor) {
                  unitDescriptor = propertyData[0].Properties[0].UnitDescriptor;
                } else {
                  this.logger.logInfo("PmPropertyDescriptionService", "unit details not found for " + propertyId)
                }
                if (propertyData[0].Properties[0].Resolution) {
                  resolution = propertyData[0].Properties[0].Resolution;
                } else {
                  this.logger.logInfo("PmPropertyDescriptionService", "Resolution details not found for " + propertyId)
                }
              }
            }

            if (dpData && dpData.length > 0 && dpData[0].Nodes.length > 0 && dpData[0].Nodes[0].Descriptor) {
              dpDescriptor = dpData[0].Nodes[0].Descriptor;
            }
            else {
              this.logger.logInfo("PmPropertyDescriptionService", "Unable to get point/device description for " + propertyId)
            }
          }
          propertyDetail = {
            DataPointName: dpName,
            DataPointDescription: dpDescriptor,
            PropertyName: propertyDescriptor,
            PropertyDescription: propertyDescriptor,
            Unit: unitDescriptor,
            Resolution:resolution,
          }

          observer.next(propertyDetail);
          observer.complete();
        }, error => {
          this.logger.logError('PmPropertyDescriptionService', "unable to get dpid for:" + error);
          observer.next(propertyDetail);
          observer.complete();
        });
      }
      else {
        observer.next(propertyDetail);
      }
    })
    return result;
  }
}